import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-system-action-list',
  templateUrl: './system-action-list.component.html',
  styleUrls: ['./system-action-list.component.scss']
})
export class SystemActionListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
